import { render, staticRenderFns } from "./InstitutionsTypes.html?vue&type=template&id=28b3039a&external"
import script from "./InstitutionsTypes.js?vue&type=script&lang=js&external"
export * from "./InstitutionsTypes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports